











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MainFooterBlock extends Vue {
  @Prop({ type: String, default: 'продолжительность' })
  readonly name!: string;

  @Prop({ type: String, default: 'time' })
  readonly type!: string;

  get classMod(): string {
    return `block__icon_${this.type}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/modulemain/components/mainfootericonblock/MainFooterBlock.vue